import axios from "axios";

const instance = axios.create({
  baseURL: "https://web1024.docmaster.in:5007/api/school/quiz", // live
  // baseURL: "http://localhost:5007/api/school/quiz", // local
});

// ✅ Request interceptor (no token logic now)
instance.interceptors.request.use((config) => {
  // No Authorization header added
  return config;
});

// ✅ Response interceptor (no auto-logout logic now)
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // You can still handle generic errors if needed
    return Promise.reject(error);
  }
);

export default instance;

// // old workng code
// let logoutPromise = null; // 🔑 shared logout promise

// const instance = axios.create({
//   // baseURL: "https://web1024.docmaster.in:5007/api/quiz", // live
//   baseURL: "http://192.168.0.230:5007/api/quiz", // local
// });

// // ✅ Request interceptor: attach token
// instance.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// // ✅ Response interceptor: centralized error handling
// instance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response) {
//       const status = error.response.status;

//       // 🔒 Handle session expiry (401 / 403)
//       if (status === 401 || status === 403) {
//         const currentPath = window.location.pathname;

//         // ✅ Only logout if not on quizHome
//         if (!currentPath.includes("/quiz")) {
//           if (!logoutPromise) {
//             logoutPromise = new Promise((resolve) => {
//               alert("Session expired. Please login again.");
//               localStorage.removeItem("userData_quiz");
//               localStorage.removeItem("token");

//               // Small delay ensures all failed requests settle before redirect
//               setTimeout(() => {
//                 window.location.href = "/quiz";
//                 resolve();
//               }, 0);
//             });
//           }
//           return logoutPromise;
//         }
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default instance;

// import axios from "axios";

// let logoutPromise = null; // 🔑 shared logout promise

// const instance = axios.create({
//   baseURL: "https://web1024.docmaster.in:5007/api/quiz", // live
//   // baseURL: "http://192.168.0.19:5007/api/quiz", // local
// });

// // ✅ Request interceptor: attach token
// instance.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// // ✅ Response interceptor: centralized error handling
// instance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response) {
//       const status = error.response.status;

//       // 🔒 Handle session expiry (401 / 403)
//       if (status === 401 || status === 403) {
//         // If no logout process running → create one
//         if (!logoutPromise) {
//           logoutPromise = new Promise((resolve) => {
//             alert("Session expired. Please login again.");
//             localStorage.removeItem("userData_quiz");
//             localStorage.removeItem("token");

//             // Small delay ensures all failed requests settle before redirect
//             setTimeout(() => {
//               window.location.href = "/quiz";
//               resolve();
//             }, 0);
//           });
//         }

//         // All requests share same logout flow
//         return logoutPromise;
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default instance;

// // old
// import axios from "axios";
// const instance = axios.create({
//   baseURL: "https://web1024.docmaster.in:5007/api/quiz", // live
//   // baseURL: "http://192.168.0.19:5007/api/quiz", // local
// });

// instance.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// export default instance;
